'use client';

import { useContext, useState, useEffect } from 'react';
import { LocaleContext } from '@/providers/UserLocaleProvider';
import { useSelector } from 'react-redux';
import { RootState } from '@/store/store';

// Type for UI strings based on UiStringsEn
// type UiStrings = typeof UiStringsEn;

// Cache for the lazy-loaded strings

const localeMap = {
  russian: "UiStringsRu",
  english: "UiStringsEn",
  spanish: "UiStringsEs",
  arabic: "UiStringsAr",
};

/**
 * Hook for accessing the user's locale and UI strings
 * @returns An object containing the current locale and UI strings
 */
export function useUserLocale() {
  const context = useContext(LocaleContext);
  
  return context;
} 